import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media } from '../../styles/constants';

const CircleSvgContainer = styled.svg`
  position: absolute;
  width: 18rem;
  height: 18rem;

  @media (min-width: ${media.phone}) {
    width: 22.5rem;
    height: 22.5rem;
  }

  @media (min-width: ${media.tabletPortrait}) {
    width: 36rem;
    height: 36rem;
    left: 50%;
    transform: translate(-50%, 0);
  }

  @media (min-width: ${media.tabletLandscape}) {
    width: 40rem;
    height: 40rem;
  }

  @media (min-width: ${media.desktop}) {
    width: 45rem;
    height: 45rem;
  }
`;

export const CircleSvg = ({ color }) => (
  <CircleSvgContainer viewBox="0 0 398 397">
    <circle
      cx="198.045145"
      cy="198.063585"
      r="198.045145"
      fill={color}
      opacity="0.9"
    />
  </CircleSvgContainer>
);

CircleSvg.propTypes = {
  color: PropTypes.string.isRequired
};

const SmallCircleSvgContainer = styled.svg`
  position: absolute;

  width: 16.3rem;
  height: 16.3rem;

  @media (min-width: ${media.tabletPortrait}) {
    width: 17rem;
    height: 17rem;
    left: 50%;
    transform: translate(-50%, 0);
  }

  @media (min-width: ${media.tabletLandscape}) {
    width: 21.4rem;
    height: 21.4rem;
  }
`;

export const SmallCircleSvg = ({ color }) => (
  <SmallCircleSvgContainer viewBox="0 0 215 215">
    <circle
      cx="107.021842"
      cy="107.584002"
      r="106.926113"
      fill={color}
      opacity="0.9"
    />
  </SmallCircleSvgContainer>
);

SmallCircleSvg.propTypes = {
  color: PropTypes.string.isRequired
};

export default SmallCircleSvg;
